import { ca } from '@cian/analytics';

import { EFrequency } from 'shared/repositories/saved-searches/entities/create_saved_search/CreateSavedSearchWebPublicRequestSchema';

interface ITrackSubscribedParameters {
  jsonQuery: unknown;
  frequency: EFrequency;
  subscribeToNews: boolean;
  subscribeToPushAvailable: boolean;
  subscribeToPush: boolean;
}

const notificationFrequencyMap: { [key in EFrequency]: string } = {
  [EFrequency.Asap]: 'Asap',
  [EFrequency.Hourly]: 'Hourly',
  [EFrequency.Daily]: 'Daily',
  [EFrequency.Weekly]: 'Weekly',
};

export function trackSaveSearchSubscribed({
  jsonQuery,
  frequency,
  subscribeToNews,
  subscribeToPushAvailable,
  subscribeToPush,
}: ITrackSubscribedParameters) {
  let label = 'From_cat_save';

  label += `/${notificationFrequencyMap[frequency]}`;

  if (subscribeToPushAvailable) {
    const pushOnOff = subscribeToPush ? 'PushOn' : 'PushOff';

    label += `/${pushOnOff}`;
  }

  ca('event', {
    name: 'oldevent',
    category: 'subscription',
    action: 'Send',
    label,
  });

  if (subscribeToNews) {
    ca('eventSite', {
      name: 'oldevent',
      action: 'Send',
      category: 'subscription',
      label: 'news',
      sc: jsonQuery,
    });
  }
}
